import React, { useState, useEffect } from "react";
import { useAuthContext } from "../hooks/useAuthContext";
import { getRoleDisplay } from "../utils/getRoleDisplay";
import Loading from "../utils/Loading";
import { Link, useParams } from "react-router-dom";
import { USERS_BASE_URL } from "../services/SignUpService";
import axios from "axios";

const MeProfile = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const { id } = useParams(); // Fetch user id from URL params

  useEffect(() => {
    if (user) {
      setLoading(false);
    } else {
      setError({ message: "User data not found" });
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error.message}</div>;
  }

  const {
    photo,
    firstName,
    lastName,
    email,
    role,
    isAdmin,
    isVerified,
    createdAt,
  } = user;
  console.log("My profile:" + user);

  const deleteAccount = (e) => {
    e.preventDefault();
    //send a delete request to users api
    try {
      alert("Are you sure?");
      axios.delete(`${USERS_BASE_URL}/api/users/list/delete/${id}`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="me-profile">
      <h1 className="bg-white p-3">
        My Profile <hr />
      </h1>
      <div className="container mt-4 mb-4">
        <form>
          <div className="row">
            <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-2 ">
              <div className="card text-center">
                <div className="card-body">
                  <img
                    src={(user && user.photo) || "https://i.pravatar.cc/50"}
                    alt={(user && user.photo) || "User Profile"}
                    className="rounded-circle mb-3"
                    style={{ width: "50px", height: "50px" }}
                  />
                  <p>
                    {user.firstName} {user.lastName.slice(0, 1)}.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
              <div className="card text-muted">
                <div className="card-header">
                  <h4 className="card-title">My Account Details</h4>
                  <p>
                    Welcome, {user.firstName} {user.lastName}
                  </p>
                  <hr />
                  <div className="float-end p-2">
                    <i className="fa fa-lock" aria-hidden="true"></i> &nbsp;
                    <b>Admin: &nbsp; </b>
                    {isAdmin ? (
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    ) : (
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    )}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i
                      className="fa fa-check-square"
                      aria-hidden="true"
                    ></i>{" "}
                    <b>Verified:&nbsp; </b>
                    {isVerified ? (
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    ) : (
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    )}
                  </div>
                </div>

                <div className="card-body">
                  <div className="card-text">
                    <h5>First Name</h5>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg text-uppercase me-2"
                        placeholder={(user && user.firstName) || ""}
                        value={(user && user.firstName) || ""}
                        disabled
                      />
                    </div>
                    <h5>Last Name</h5>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg text-uppercase me-2"
                        placeholder={(user && user.lastName) || ""}
                        value={(user && user.lastName) || ""}
                        disabled
                      />
                    </div>
                    <h5>Email Address</h5>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg text-uppercase me-2"
                        placeholder={(user && user.email) || ""}
                        value={(user && user.email) || ""}
                        disabled
                      />
                    </div>
                    <h5>Your Role</h5>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className={`${
                          user && user?.isAdmin
                            ? "bg-warning form-control form-control-lg text-uppercase text-white me-2"
                            : "form-control form-control-lg text-uppercase me-2"
                        }`}
                        placeholder={getRoleDisplay(user)}
                        value={getRoleDisplay(user)}
                        disabled
                      />
                    </div>
                    <p className="card-text text-muted mb-0 mt-4">
                      <strong>Joined:</strong>{" "}
                      {createdAt
                        ? new Date(createdAt).toLocaleDateString()
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="float-center d-flex mt-4 mb-4">
                <Link
                  className="btn btn-outline-success btn-lg me-4"
                  title="Edit Account"
                  to={`/api/dashboard/user-profile/${user._id}`}
                >
                  <i className="fa fa-pencil-square-o"></i> Edit
                </Link>

                <button
                  className="btn btn-outline-danger btn-lg"
                  disabled={isAdmin}
                  onClick={(e) => deleteAccount(e)}
                >
                  <i className="fa fa-trash"></i> Close Account
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default MeProfile;
